var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"d-flex align-items-center"},[_vm._t("title",[_c('h4',{staticClass:"flex-grow-1"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._t("controls"),_c('nav-menu')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }